<template>
   <label
      v-if="$slots.default"
      class="flex items-center gap-3"
      :class="{
         'opacity-60': disabled,
         'ml-4': !physicalPermit,
         'ml-2 !text-[9px] opacity-100': physicalPermit,
         '!ml-0': noMargin,
      }"
   >
      <slot />
      <span v-if="extra" class="p-s text-grey bg-light-grey rounded-full px-2">
         {{ extra }}
      </span>
   </label>
</template>

<script lang="ts" setup>
type Props = {
   disabled?: boolean
   physicalPermit?: boolean
   noMargin?: boolean
   extra?: string
}

const props = withDefaults(defineProps<Props>(), {})

const { t } = useI18n()
</script>
